import Service from "./Service";
import {
  ApprovalInfo,
  BookClerk,
  TravelFlightItinerary,
  TravelHotelItinerary,
  TravelTrainItinerary,
  TravelCarItinerary,
  CompanyInfo,
  DepartmentInfo,
  FlightOrderInfo,
  AirBaseOrder,
  AirTicketInfo,
  AirFlightInfo,
  AirPassengerInfo,
  AirChangeInfo,
  AirRefundInfo,
  AirTicketPrint,
  AirExceedInfo,
  AirInsurance,
  HotelOrderInfoEntity,
  HotelBaseInfo,
  HotelExceedInfo,
  HotelPassengInfo,
  LoginInfo,
  OrderSearch,
  TrainOrderInfoEntity,
  TrainBaseOrder,
  TrainTicketInfo,
  TrainSequenceInfo,
  TrainPassengerInfo,
  TrainChangeInfo,
  TrainRefundInfo,
  UserInfo,
  UserCardInfo,
} from "../model/Huilianyi";
class huilianyiService extends Service {
  searchapprovals() {
    return this.post<ApprovalInfo>(`/huilianyi/searchApproval?status=`, {});
  }
  booking(id: any) {
    return this.get<any>("/huilianyi/booking?id=" + id);
  }
}
export default new huilianyiService("huilianyi");